module.exports = new __parcel__URL__("36116_h.01cecf0d.jpg").toString();